exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".list-item[data-v-00bab420]{display:inline-block;margin-right:10px}.list-enter-active[data-v-00bab420],.list-leave-active[data-v-00bab420]{transition:all 1s}.list-enter[data-v-00bab420],.list-leave-to[data-v-00bab420]{opacity:0;transform:translateY(-30px)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-00bab420","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/core/components/mdNotifications/index.vue
// module id = 1006
// module chunks = 0